const EDITABLE_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'ION-INPUT', 'ION-TEXTAREA', 'ION-SEARCHBAR', 'ION-SELECT'];

export const KEYBOARD_UTILS = {
  /**
   * Whether a key event came from somewhere the user is typing. Global `window:keydown`
   * handlers can check this before acting on a bare key.
   * Walks the composed path rather than reading `event.target`, because an Ionic input
   * keeps its native element in a shadow root. Both the native and the `ion-*` tags
   * are matched so either form is caught.
   */
  isFromEditableElement(event: KeyboardEvent): boolean {
    const composedPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const nodes = composedPath.length ? composedPath : [event.target];

    return nodes.some((node) => {
      const element = node as HTMLElement;
      if (!element?.tagName) return false;

      return EDITABLE_TAGS.includes(element.tagName) || element.isContentEditable;
    });
  },
};
